import SelectProperty from './Select';

export default function SelectCreatableProperty({ ...props }) {
  return <SelectProperty {...props}
    creatable
  />
}
